import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d975683"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box animate__animated animate__fadeInUp animate__faster fixed z-50 bottom-0 right-0 mb-5 mr-5 bg-white rounded-xl py-5 px-5 flex items-center flex-col shadow-xl select-none" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 1,
  class: "text-xl font-black text-center text-brand-main"
}
const _hoisted_4 = {
  key: 0,
  class: "text-gray-800 text-sm flex"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1 font-bold" }, "showMeTheProblem", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UseIcon = _resolveComponent("UseIcon")!
  const _component_WizardFeedback = _resolveComponent("WizardFeedback")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: _normalizeClass(["relative w-full flex", {
                'justify-between': _ctx.canShowAdditionalControlAndInfo,
                'justify-end': !_ctx.canShowAdditionalControlAndInfo,
            }])
    }, [
      (_ctx.canShowAdditionalControlAndInfo)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
            type: "button",
            disabled: _ctx.canGoBack,
            class: _normalizeClass([{ invisible: _ctx.canGoBack }, "text-xl text-gray-800 focus:outline-none"])
          }, [
            _createVNode(_component_UseIcon, {
              name: "IconBack",
              color: _ctx.colors.gray['800']
            }, null, 8, ["color"])
          ], 10, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.canShowAdditionalControlAndInfo)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = () => _ctx.emit('close-box')),
        class: "text-xl text-gray-800 focus:outline-none"
      }, [
        _createVNode(_component_UseIcon, {
          name: "IconClose",
          size: "14",
          color: _ctx.colors.gray['800']
        }, null, 8, ["color"])
      ])
    ], 2),
    _createVNode(_component_WizardFeedback),
    (_ctx.canShowAdditionalControlAndInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_UseIcon, {
            class: "mr-1",
            name: "IconChat",
            size: "14",
            color: _ctx.colors.gray['500']
          }, null, 8, ["color"]),
          _createTextVNode(" widget by "),
          _hoisted_5
        ]))
      : _createCommentVNode("", true)
  ]))
}